import "./STPremiumPage.css";

import React, { useEffect, useState } from "react";
import {
  getAllSubscriptions,
  getPersonalizedTicketList,
  getRequestorList,
  getTicketList,
} from "Config/API/get";
import {
  notConnectedAmniusAction,
  raiseRequestDataAction,
  selectedOrganizationSTAction,
} from "Redux/action/variable.action";
import { useDispatch, useSelector } from "react-redux";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Headers from "Components/Header/Headers";
import Navigation from "Components/SideNavBar/Navigation";
import SearchIcon from "@mui/icons-material/Search";
import SeverityLabel from "../../Common/SeverityLabel";
import { ticketIdAction } from "Redux/action/variable.action";
import { toast } from "react-toastify";
import useFullPageLoader from "Hooks/useFullPageLoader";
import { useNavigate } from "react-router-dom";
import RenderRequestTypePopup from "Components/Popup/RequestTypePopup/Container/RenderRequestTypePopup";
import RenderTicketTypePopup from "Components/Popup/RenderTicketTypePopup";
import RenderConfirmoption from "Components/Popup/Option/Container/RenderConfirm";

const DONE_TYPING_INTERVAL = 1500;

const SEVERITY_FILTER_OPTIONS = [
  { value: "all", label: "All" },
  { value: "urgent", label: "Urgent" },
  { value: "moderate", label: "Moderate" },
  { value: "low", label: "Low" },
  { value: "pause", label: "Pause" },
  { value: "closed", label: "Closed" },
];

const withoutClosed = (tickets) =>
  tickets?.filter((item) => item?.severity_issue !== "closed");

const scheduledStatusColor = (status) =>
  status === "green" ? "#5ca127" : "#d81c1c";

const SeverityFilterOptions = () =>
  SEVERITY_FILTER_OPTIONS.map(({ value, label }) => (
    <option key={value} value={value}>
      {label}
    </option>
  ));

const STPremiumPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let typingTimer;
  const loggedInUserDetails = useSelector(
    (state) => state.authenticationReducer
  );
  const pageType = useSelector((state) => state.servicePageTypeReducer);
  const [loader, setLoader, resetLoader] = useFullPageLoader();

  const [ticketList, setTicketList] = useState("");
  const [personalizedTicketList, setPersonalizedTicketList] = useState("");
  const token = localStorage.getItem("token");

  const [searchKeyword, setSearchKeyword] = useState("");
  const [filterKeyword, setFilterKeyword] = useState("");
  const [personalizedFilterKeyword, setPersonalizedFilterKeyword] =
    useState("");
  const [requestTypeconfirmPopup, setRequestTypeConfirmPopup] = useState(false);
  const [generalticket, setGeneralticket] = useState(false);
  const [requestOption, setRequestOption] = useState("");
  const [ticketOption, setTicketOption] = useState("");
  const [confirmPopup, setConfirmPopup] = useState(false);

  const isPremiumPage = pageType?.toString() === "PREMIUM";
  const canCreateTicket =
    loggedInUserDetails?.ticket_internal_role === "manager" ||
    loggedInUserDetails?.ticket_external_role === "manager";
  const canViewInternalTickets =
    loggedInUserDetails?.ticket_internal_read_role === "manager";
  const canViewTicketTabs =
    loggedInUserDetails?.ticket_external_read_role === "manager" ||
    canViewInternalTickets;

  useEffect(() => {
    if (pageType === undefined) {
      navigate("/service-ticket-dashboard");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // get all subscriptions
  useEffect(() => {
    getAllSubscriptions(token).then((res) => {
      if (res?.data?.status) {
        const filteredSubscription = res.data.data?.filter(
          (item) => item?.subscription_type === "service_ticket"
        );
        if (
          filteredSubscription[0]?.subscriptionStatus?.toString() === "false" &&
          pageType?.toString() !== "NON-PREMIUM"
        ) {
          navigate("/service-ticket-dashboard");
          toast("You don't have access of this Service", { type: "info" });
          return;
        }
      } else toast("Failed! Try again later", { type: "error" });
    });
  });

  // Stores the main ticket list from an API response (or shows its error)
  const showTickets = (res, hideClosed) => {
    resetLoader();
    if (res?.status) {
      setTicketList(hideClosed ? withoutClosed(res?.ticket) : res?.ticket);
    } else toast(res?.message, { type: "error" });
  };

  // get ticket list
  useEffect(() => {
    setLoader();
    if (isPremiumPage) {
      getTicketList(token, "", "", "", "").then((res) =>
        showTickets(res, true)
      );

      getPersonalizedTicketList(token, "", "", "external").then((res) => {
        if (res?.status) {
          setPersonalizedTicketList(withoutClosed(res?.ticket));
        }
      });
    } else {
      getRequestorList(token, "", "").then((res) => showTickets(res, true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filter_function = (value) => {
    setLoader();
    const request = isPremiumPage
      ? getTicketList(token, value, searchKeyword, "", "")
      : getRequestorList(token, value, searchKeyword);
    request.then((res) => showTickets(res, value === "all"));
  };

  const personalized_filter_function = (value) => {
    setLoader();
    getPersonalizedTicketList(token, value, searchKeyword, "external").then(
      (res) => {
        resetLoader();
        if (res?.status) {
          setPersonalizedTicketList(
            value === "all" ? withoutClosed(res?.ticket) : res?.ticket
          );
        } else toast(res?.message, { type: "error" });
      }
    );
  };

  const search_fuction = (value) => {
    setLoader();
    if (isPremiumPage) {
      getTicketList(token, filterKeyword, value, "", "").then((res) =>
        showTickets(res, false)
      );

      getPersonalizedTicketList(
        token,
        personalizedFilterKeyword,
        value,
        "external"
      ).then((res) => {
        if (res?.status) {
          setPersonalizedTicketList(res?.ticket);
        }
      });
    } else {
      getRequestorList(token, filterKeyword, value).then((res) =>
        showTickets(res, false)
      );
    }
  };

  // creating tickets: first the request type, then the ticket type
  const handleRequestType = (option) => {
    setGeneralticket(true);
    setRequestOption(option);
    setRequestTypeConfirmPopup(false);
  };

  const handleTicketType = (selectedTicketOption) => {
    const isInternalRequest = requestOption === "Internal";

    if (selectedTicketOption === "General") {
      if (isInternalRequest) {
        navigate("/create-general-internal-service-ticket");
      } else {
        setConfirmPopup(true);
      }
    } else if (selectedTicketOption === "Asset") {
      if (isInternalRequest) {
        navigate("/create-internal-service-ticket", { state: "new ticket" });
      } else {
        setConfirmPopup(true);
      }
    }
    setTicketOption(selectedTicketOption);
    setGeneralticket(false);
  };

  // connected or not function
  const connectedFunction = (option) => {
    const createPage =
      ticketOption === "Asset"
        ? "/service-ticket-create"
        : "/service-ticket-create-general";

    dispatch(notConnectedAmniusAction(option?.toString() !== "Yes"));
    navigate(createPage, { state: "new ticket" });
    dispatch(selectedOrganizationSTAction(""));
    dispatch(raiseRequestDataAction(""));
  };

  return (
    <>
      <div className="stpmain-parent">
        <div className="stpmain-header">
          <Headers />
        </div>

        <div className="stpmain-navigation">
          <Navigation />
        </div>

        <div className="stpmain-main">
          <div className="stpmain-ticket-search">
            <input
              type="search"
              placeholder={
                isPremiumPage
                  ? "Search tickets by ticket # or requestor name"
                  : "Search tickets by ticket # or provider name"
              }
              onChange={(e) => {
                typingTimer = setTimeout(() => {
                  search_fuction(e.target.value);
                  setSearchKeyword(e.target.value);
                }, DONE_TYPING_INTERVAL);
              }}
            />
            <SearchIcon />
          </div>
          {isPremiumPage && canViewTicketTabs ? (
            <div className="stpmain-options-btn">
              <button
                className="stpmain-outline-btn-active"
                onClick={() => navigate("/service-ticket-view-page")}
              >
                EXTERNAL TICKETS
              </button>
              <button
                disabled={!canCreateTicket}
                className={canCreateTicket ? "create-ticket" : "external-rights"}
                onClick={() => setRequestTypeConfirmPopup(true)}
              >
                Create New Ticket
              </button>
              <button
                className={
                  canViewInternalTickets ? "stpmain-outline-btn" : "external-rights"
                }
                onClick={() => {
                  if (canViewInternalTickets) {
                    navigate("/all-internal-service-tickets");
                  }
                }}
              >
                INTERNAL TICKETS
              </button>
            </div>
          ) : null}
          <div className="stpmain-wrapper">
            <div className="stpmain-all-active">
              <div className="stpmain-top">
                <p className="sttop-heading">All Active Service Tickets</p>
                <div>
                  <p>Filter:</p>
                  <select
                    onChange={(e) => {
                      filter_function(e.target.value);
                      setFilterKeyword(e.target.value);
                    }}
                  >
                    <SeverityFilterOptions />
                  </select>
                </div>
              </div>
              <div className="stpmain-row-wrapper">
                <div className="stpmain-head-row" style={{ width: "25%" }}>
                  TICKET #
                </div>
                <div className="stpmain-head-row">
                  {isPremiumPage ? "REQUESTOR" : "PROVIDER"}
                </div>
                <div className="stpmain-head-row">ASSIGNED TECH</div>
                <div className="stpmain-head-row">SEVERITY</div>
                <div className="stpmain-head-row">DATE OPENED</div>
              </div>
              <div className="stpmain-bottom">
                {ticketList?.length?.toString() !== "0" ? (
                  ticketList?.map((curr, index) => (
                    <div className="stpmain-content-wrapper" key={index}>
                      <div
                        className="stpmain-content-row"
                        style={{ width: "25%" }}
                        onClick={() => {
                          dispatch(ticketIdAction(curr?.ticket_id));
                          navigate("/service-ticket-details");
                        }}
                      >
                        {curr?.ticket_id}
                      </div>
                      <div className="stpmain-content-row">
                        {isPremiumPage ? curr?.requestor : curr?.provider}
                      </div>
                      <div className="stpmain-content-row">
                        {curr?.assign_tech}
                      </div>
                      <div className="stpmain-content-row">
                        <SeverityLabel severity={curr?.severity_issue} />
                      </div>
                      <div
                        className="stpmain-content-row stpmain-date-row"
                        style={{ position: "relative" }}
                      >
                        {curr?.create_at}

                        {curr?.scheduled_status?.toString() !== "no" ? (
                          <AccessTimeIcon
                            style={{
                              color: scheduledStatusColor(curr?.scheduled_status),
                            }}
                          />
                        ) : null}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="stpmain-msg">No Tickets Found</div>
                )}
              </div>
            </div>
            {isPremiumPage ? (
              <div className="stpmain-my-active">
                <div className="stpmain-top ">
                  <p className="sttop-heading">My Active Service Tickets</p>
                  <div>
                    <p>Filter:</p>
                    <select
                      onChange={(e) => {
                        personalized_filter_function(e.target.value);
                        setPersonalizedFilterKeyword(e.target.value);
                      }}
                    >
                      <SeverityFilterOptions />
                    </select>
                  </div>
                </div>
                <div className="stpmain-row-wrapper stpmain-right-side">
                  <div className="stpmain-head-row" style={{ width: "25%" }}>
                    TICKET #
                  </div>
                  <div className="stpmain-head-row">REQUESTOR</div>
                  <div className="stpmain-head-row">SEVERITY</div>
                  <div className="stpmain-head-row">DATE OPENED</div>
                </div>
                <div className="stpmain-bottom stpmain-right-side">
                  {personalizedTicketList?.length?.toString() !== "0" ? (
                    personalizedTicketList?.map((curr, index) => (
                      <div className="stpmain-content-wrapper" key={index}>
                        <div
                          className="stpmain-content-row"
                          style={{ width: "25%" }}
                          onClick={() => {
                            dispatch(ticketIdAction(curr?.ticket_id));
                            navigate("/service-ticket-details");
                          }}
                        >
                          {curr?.ticket_id}
                        </div>
                        <div className="stpmain-content-row">
                          {curr?.requestor}
                        </div>
                        <div className="stpmain-content-row">
                          <SeverityLabel severity={curr?.severity_issue} />
                        </div>
                        <div
                          className="stpmain-content-row stpmain-date-row"
                          style={{ position: "relative" }}
                        >
                          {curr?.create_at}

                          {curr?.scheduled_status?.toString() !== "no" ? (
                            <AccessTimeIcon
                              style={{
                                color: scheduledStatusColor(
                                  curr?.scheduled_status?.toString()
                                ),
                              }}
                            />
                          ) : null}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="stpmain-msg">No Tickets Found</div>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {requestTypeconfirmPopup ? (
        <RenderRequestTypePopup
          message={"Please Select Request Type"}
          option1={"External"}
          option2={"Internal"}
          funct={handleRequestType}
          hide={setRequestTypeConfirmPopup}
        />
      ) : null}
      {generalticket ? (
        <RenderTicketTypePopup
          message={"Please Select Ticket Type"}
          option1={"General"}
          option2={"Asset"}
          funct={handleTicketType}
          hide={setGeneralticket}
        />
      ) : null}
      {confirmPopup ? (
        <RenderConfirmoption
          message={"Is Requestor A Connected Amnius User?"}
          option1={"Yes"}
          option2={"No"}
          funct={connectedFunction}
          hide={setConfirmPopup}
        />
      ) : null}
      {loader}
    </>
  );
};

export default STPremiumPage;
